import { render, staticRenderFns } from "./dev-monitor.component.vue?vue&type=template&id=89717d0c"
import script from "./dev-monitor.component.ts?vue&type=script&lang=ts&external"
export * from "./dev-monitor.component.ts?vue&type=script&lang=ts&external"
import style0 from "./dev-monitor.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports